module.exports = __webpack_public_path__ + "static/media/icon_bq_cd_06展开.248b93b0.svg";